import { useState } from 'react'
import validator from 'validator'

export const useForm = (submitCallback, initialState = {}) => {
    const [values, setValue] = useState(initialState)
    const [validated, setValidated] = useState(false)

    const onChange = (event, prefix) => {
        const newValue = prefix
            ? { ...values, [prefix]: { ...values[prefix], [event.target.name]: event.target.value } }
            : { ...values, [event.target.name]: event.target.value }
        setValue(newValue)
    }

    const onFileChange = (event, prefix = '') => {
        if (event.target.files) {
            const newValue = prefix
                ? { ...values, [prefix]: { ...values[prefix], [event.target.name]: event.target.files[0] } }
                : { ...values, [event.target.name]: event.target.files[0] }
            setValue(newValue)
        }
    }

    const validateForm = (event, prefix) => {
        const form = event.target.form || event.currentTarget //currentTarget should always be the form

        if (form.checkValidity()) {
            try {
                submitCallback(values, prefix)
            } catch (error) {
                console.error("Error in form submission callback:", error)
            }
        }

        setValidated(true)
    }

    const onSubmit = (event, prefix) => {
        event.preventDefault()
        event.stopPropagation()

        validateForm(event, prefix)
    }

    const validateEmail = (event) => {
        if (validator.isEmail(event.target.value)) {
            event.target.setCustomValidity('')
        } else {
            event.target.setCustomValidity('Please enter a valid Email')
        }
    }

    const resetValidation = () => {
        setValidated(false)
    }

    return {
        onChange,
        onFileChange,
        onSubmit,
        values,
        validated,
        validateEmail,
        setValue,
        resetValidation,
    }
}
